import { useMemo, useState } from 'react';
import { buildYearOptions, currentGregorianYear, currentJalaliYear, gregorianToJalaliYear, jalaliToGregorianYear, toEnglishDigits, toPersianDigits } from './vehicleRegisterUtils';

export default function VehicleYearPicker({ jalaliValue, gregorianValue, errors = {}, disabled, onChange }) {
  const [open, setOpen] = useState(false);
  const [calendar, setCalendar] = useState('jalali');
  const [manualYear, setManualYear] = useState('');
  const [manualError, setManualError] = useState('');
  const options = useMemo(() => buildYearOptions(calendar), [calendar]);

  const valueFor = type => type === 'jalali' ? jalaliValue : gregorianValue;
  const chooseCalendar = type => {
    setCalendar(type);
    setManualYear(valueFor(type));
    setManualError('');
  };
  const show = type => { chooseCalendar(type); setOpen(true); };
  const apply = year => {
    const jalali = calendar === 'jalali' ? year : gregorianToJalaliYear(year);
    const gregorian = calendar === 'gregorian' ? year : jalaliToGregorianYear(year);
    onChange({ jalali: toPersianDigits(jalali), gregorian: toPersianDigits(gregorian) });
    setOpen(false);
  };
  const confirmManual = () => {
    const year = toEnglishDigits(manualYear);
    const min = calendar === 'jalali' ? 1300 : 1921;
    const max = calendar === 'jalali' ? currentJalaliYear() : currentGregorianYear();
    if (!/^\d{4}$/.test(year) || Number(year) < min || Number(year) > max) {
      setManualError(calendar === 'jalali' ? 'سال شمسی معتبر نیست' : 'سال میلادی معتبر نیست');
      return;
    }
    apply(Number(year));
  };

  return <>
    <div className="veh-year">
      <div className="veh-year__fields">
        {[{ type: 'jalali', label: 'سال شمسی', placeholder: 'تاریخ را وارد کنید', value: jalaliValue, error: errors.productionYearJalali }, { type: 'gregorian', label: 'سال میلادی', placeholder: 'تاریخ را وارد کنید', value: gregorianValue, error: errors.productionYearGregorian }].map(item => <div className="veh-year__field" key={item.type}>
          <span>{item.label}</span>
          <button type="button" aria-label={item.type === 'jalali' ? 'شمسی' : 'میلادی'} className={`veh-year__trigger${!item.value ? ' is-placeholder' : ''}${item.error ? ' is-error' : ''}`} onClick={() => show(item.type)} disabled={disabled}><b>{item.value || item.placeholder}</b><i aria-hidden="true" /></button>
          {item.error && <small className="veh-reg__field-error">{item.error}</small>}
        </div>)}
      </div>
    </div>

    {open && <div className="veh-picker-overlay" onClick={event => { event.stopPropagation(); setOpen(false); }}>
      <div className="veh-picker veh-year-picker" role="dialog" aria-modal="true" aria-label={`انتخاب سال ساخت ${calendar === 'jalali' ? 'شمسی' : 'میلادی'}`} onClick={event => event.stopPropagation()}>
        <div className="veh-picker__head"><div><b>انتخاب سال ساخت</b><small>تقویم موردنظر را انتخاب کنید</small></div><button type="button" onClick={() => setOpen(false)} aria-label="بستن انتخاب سال">×</button></div>
        <div className="veh-picker__tabs"><button type="button" className={calendar === 'jalali' ? 'is-active' : ''} onClick={() => chooseCalendar('jalali')}>شمسی</button><button type="button" className={calendar === 'gregorian' ? 'is-active' : ''} onClick={() => chooseCalendar('gregorian')}>میلادی</button></div>
        <div className="veh-year-picker__manual"><input aria-label={`ورود دستی سال ساخت ${calendar === 'jalali' ? 'شمسی' : 'میلادی'}`} value={manualYear} onChange={event => { setManualYear(toPersianDigits(toEnglishDigits(event.target.value).replace(/[^\d]/g, '').slice(0, 4))); setManualError(''); }} inputMode="numeric" maxLength={4} placeholder={calendar === 'jalali' ? 'مثال: ۱۴۰۳' : 'مثال: ۲۰۲۴'} /><button type="button" onClick={confirmManual}>تأیید</button></div>
        <p className={`veh-picker__error${manualError ? ' is-visible' : ''}`}>{manualError || ' '}</p>
        <div className="veh-year-picker__list" role="listbox" aria-label={`سال‌های ${calendar === 'jalali' ? 'شمسی' : 'میلادی'} خودرو`}>{options.map(year => <button type="button" role="option" aria-selected={toEnglishDigits(valueFor(calendar)) === String(year)} key={year} onClick={() => apply(year)}>{toPersianDigits(year)}</button>)}</div>
      </div>
    </div>}
  </>;
}
